import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=88c90e3c&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=88c90e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c90e3c",
  null
  
)

export default component.exports